import { ProfileTransferPayload, CustomerResponse, TransferredEmail, UpdateEmailFormPayload } from '../../models/profile';
import axios, { AxiosResponse } from 'axios';
import { KIT_API_BASE_URL, X_OWNER, CUSTOMER_API_BASE_URL, PARTNER_API_BASE_URL, PROFILE_API_BASE_URL } from '../../constants';

export class ProfileTransferService {

  static async profileTransfer(payload: ProfileTransferPayload) {
    const response: AxiosResponse<any> = await axios.put(`${KIT_API_BASE_URL}/v1.0/profile/${payload.profileId}/owner`, { owner: payload.destination.owner, username: payload.destination.username }, { headers: { [X_OWNER]: `${payload.owner}` } });
    return response.data;
  }
  static async getCustomerId(email: string) {
    const response: AxiosResponse<CustomerResponse> = await axios.get(`${CUSTOMER_API_BASE_URL}/v1.0/customer/user/search?username=${encodeURIComponent(email)}&partner=circle`, { headers: { 'X-Owner': `*` } });
    return response.data;
  }
  static async sendReportLinkToCustomerUser(payload: TransferredEmail, partner: string) {
    const response: AxiosResponse<any> = await axios.post(`${PARTNER_API_BASE_URL}/v1.0/sendemail/partner/${partner}`, payload, { headers: { [X_OWNER]: `*` } });
    return response.data;
  }
  static async updateEmail(payload: UpdateEmailFormPayload) {
    const response: AxiosResponse<any> = await axios.patch(`${PROFILE_API_BASE_URL}/v1.0/profile/${payload.profileId}?email=true`, { profile: payload }, { headers: { 'X-Owner': `${payload.owner}` } });
    return response.data;
  }
}
